<template>
  <div>
    <b-card title="Sayfa Görseli">
      <b-img
        v-if="dataItem.image"
        :src="imageUrl + '/media/contents/' + dataItem.image"
        thumbnail
        center
      />
      <div class="text-center mt-1">
        <b-button
          variant="primary"
          @click="openModal"
        >
          <FeatherIcon icon="UploadIcon" />
          Görsel Yükle
        </b-button>
      </div>
    </b-card>
    <cropper-image
      v-if="cropperSettings.modalStatus"
      :modal-status="cropperSettings.modalStatus"
      :close-modal="closeModal"
      file-name=""
      folder="contents"
      :resize="false"
      component="contents"
      params="contents"
      :item-id="dataItem.id"
      @uploadImage="setUploadImage"
    />
  </div>
</template>
<script>
import { BCard, BImg, BButton } from 'bootstrap-vue'
import CropperImage from '@/layouts/components/common/CropperImage.vue'

export default {
  name: 'ContentsImageCard',
  components: {
    BCard,
    BImg,
    BButton,
    CropperImage,
  },
  data() {
    return {
      cropperSettings: {
        modalStatus: false,
      },
      imageUrl: this.$store.state.app.baseURL,
    }
  },
  computed: {
    dataItem() {
      return this.$store.getters['contents/dataItem']
    },
  },
  methods: {
    openModal() {
      this.cropperSettings.modalStatus = true
    },
    closeModal() {
      this.cropperSettings.modalStatus = false
    },
    setUploadImage(item) {
      this.dataItem.image = item.filename
      this.dataItem.mediaData = item
      this.cropperSettings.modalStatus = false
    },
  },
}
</script>
